import * as React from 'react';
import { FC, useState, useEffect } from 'react';
import { useContext } from './useFormContext';

const CreditCardSelectField: FC = () => {
  const context = useContext();
  const { cards } = context.extra;
  const [creditCard, setCreditCard] = useState(Object.keys(cards)[0]);

  // change currencies
  useEffect(() => {
    context.changeCurrencyGateways(cards[creditCard].currency_gateways);
  }, [creditCard]);

  return (
    <div className="rs-column-small-12">
      <label htmlFor="target">{`${context.locales.target_label}:`}</label>
      <select name="target" id="target" onChange={(e) => setCreditCard(e.target.selectedOptions[0].text)}>
        {Object.entries(cards).map((data) => (
          <option key={data[1].id} value={data[1].id}>
            {data[0]}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CreditCardSelectField;
